export function mapBankListToOptions(bankList) {
	return bankList.map((bank) => {
		const bankCode = bank.ISPB__c == "0" ? "0000000" : bank.ISPB__c;
		const bankName = bank.Description__c;
		const bankNumber = String(bank.Number__c).padStart(3, "0");

		return {
			code: bankCode,
			bank: bankName,
			number: bankNumber,
			label: `${bankNumber} - ${bankName} - ${bankCode}`,
		};
	});
}
